<div class="container" @fadeIn>
    <div fxLayout="row wrap" class="header m-b-10">
        <div fxFlex="93">
            <span class="header-text">{{activeQuestion.title}}</span>
        </div>
        <div class="pointer" (click)="onClosePopup()">
            <mat-icon>clear</mat-icon>
        </div>
    </div>
    <form *ngIf="activeQuestion.title" (ngSubmit)="onSubmit()" [formGroup]="questionForm">
        <div fxLayout="row wrap">
            <div @fadeIn fxFlex="100" *ngIf="activeQuestion.type=='short_text'">
                <mat-form-field>
                    <input matInput autocomplete="off" type="text" placeholder={{activeQuestion.placeholder}}
                        formControlName="field">
                </mat-form-field>
            </div>
            <div @fadeIn fxFlex="100" *ngIf="activeQuestion.type=='phone_number'">
                <mat-form-field>
                    <input matInput autocomplete="off" type="tel" placeholder={{activeQuestion.placeholder}}
                        formControlName="field">
                </mat-form-field>
            </div>
            <div @fadeIn fxFlex="100" *ngIf="activeQuestion.type=='email'">
                <mat-form-field>
                    <input matInput autocomplete="off" type="email" placeholder={{activeQuestion.placeholder}}
                        formControlName="field">
                </mat-form-field>
            </div>
            <div @fadeIn fxFlex="100" *ngIf="activeQuestion.type=='number'">
                <mat-form-field>
                    <input matInput autocomplete="off" type="number" placeholder={{activeQuestion.placeholder}}
                        formControlName="field">
                </mat-form-field>
            </div>
            <div @fadeIn fxFlex="50" *ngIf="activeQuestion.type=='date'">
                <mat-form-field>
                    <input matInput autocomplete="off" [owlDateTime]="date" [owlDateTimeTrigger]="date"
                        [placeholder]="activeQuestion.placeholder" formControlName="field">
                    <owl-date-time pickerType="calendar" #date></owl-date-time>
                    <mat-datepicker-toggle matSuffix [owlDateTimeTrigger]="date"></mat-datepicker-toggle>
                </mat-form-field>
            </div>
            <div @fadeIn fxFlex="50" *ngIf="activeQuestion.type=='date_time'">
                <mat-form-field>
                    <input matInput autocomplete="off" [owlDateTime]="date" [owlDateTimeTrigger]="date"
                        [placeholder]="activeQuestion.placeholder" formControlName="field">
                    <owl-date-time pickerType="both" #date></owl-date-time>
                    <mat-datepicker-toggle matSuffix [owlDateTimeTrigger]="date"></mat-datepicker-toggle>
                </mat-form-field>
            </div>

            <div @fadeIn fxFlex="100" *ngIf="activeQuestion.type=='dropdown'">
                <mat-form-field>
                    <mat-select [placeholder]="activeQuestion.placeholder" class="dd" formControlName="field">
                        <mat-option *ngFor="let option of activeQuestion.options" [value]="option.value">
                            {{option.label}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="long-text" @fadeIn fxFlex="100" *ngIf="activeQuestion.type=='long_text'">
                <mat-form-field appearance="outline">
                    <textarea matInput style="width: 100%;" rows="5" formControlName="field"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="m-t-20">
            <button class="m-r-20" color="primary" type="submit" mat-raised-button
                [disabled]="!questionForm.controls['field'].value&&!questionForm.valid">{{activeQuestion.button_text}}</button>
            <button *ngIf="questionNumber>0" (click)="previousQuestion()" color="secondary" type="button"
                mat-raised-button>Back</button>
        </div>
    </form>
    <div fxLayout="row" class="m-t-20" *ngIf="allQuestions.length>1">
        <mat-progress-bar color="secondary" class="progress" mode="determinate" [value]="progress"></mat-progress-bar>
    </div>
</div>